<div
  *ngIf="due_date"
  style="opacity: 0.75; display: inline-flex; align-items: center; gap: 4px"
  [ngStyle]="{
    color: color,
  }"
>
  Due: {{ due_date | moment }}
  <div
    style="
      background: red;
      color: #fff;
      padding: 2px 3px;
      border-radius: 2px;
      line-height: 1em;
    "
    *ngIf="utilities.dateDiff(due_date, 'days') > 0"
  >
    +{{ utilities.dateDiff(due_date, 'days') }}days
  </div>
</div>
